<template>
  <div>
    <div class="config_form">
      <p>公众号开发信息配置</p>
      <ul>
        <li class="lis">
          <span>开发者ID（APPID）：</span>
          <el-input v-model="queryParams.appId"></el-input>
          <span class="span2">开发者密码 ：</span>
          <el-input v-model="queryParams.secret"></el-input>
        </li>
        <li>IP白名单: 47.113.116.75</li>
        <li>网页授权域名: iot.juzi1688.cn</li>
        <li>JS接口安全域名: iot.juzi1688.cn</li>
        <li>公众号菜单URL：</li>
        <li>1) 公众号订购模板URL：{{queryParams.renewalUrl}}</li>
        <li>2)独立H5查询订购URL: http://iot.juzi1688.cn/dist/#/info?iccid = *** </li> 
      </ul>
    </div>
    <div class="config_form parameter2">
      <p>公众号开发信息配置</p>
      <ul>
        <li class="lis">
          <span>商户号 ：</span>
          <el-input v-model="queryParams.mchId"></el-input>
          <span class="span2">API密匙 ：</span>
          <el-input v-model="queryParams.mckKey"></el-input>
        </li>
        <li>JSAPI支付授权目录: iot.juzi1688.cn</li>
        <li>h5支付域名: iot.juzi1688.cn</li>
      </ul>
    </div>
    <div class="config_form parameter2">
      <p>公众号样式展示</p>
      <div class="divImg">
        <img src="../../assets/img/gzhxq.jpg" alt="">
      </div>
    </div>
    <div class="config_form parameter2">
      <p>套餐订购消息接收配置</p>
      <ul>
        <li class="lis">
          <span>接收地址URL：</span>
          <el-input v-model="queryParams.callbackUrl"></el-input>
        </li>
        <li>若需要接收公众号套餐每笔订购详情推送，可在接收地址URL处设置接收URL，我们会推送详细信息给您，信息展示如下示例：</li>
        <li class="li-can">
          <p>{</p>
          <p>"iccid":"89860918700004039282",</p>
          <p>"msisdn":"861064633253631",</p>
          <p>"order_no":"123456789987654321",</p>
          <p>"price":"20",</p>
          <p>"recharge_time":"2018-08-27 15:01:01"</p>
          <p>"active_time":"2018-08-28 16:05:01"</p>
          <p>"expired_time":"2019-08-28 16:05:01"</p>
          <p>}</p>
        </li>
        <li>字段解析：</li>
        <li style="margin-bottom: 80px;">
          <table width="100%" class="paltformTable">
            <thead>
              <tr>
                <th width="24%">字段名称</th>
                <th width="40%">字段含义</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>iccid</td>
                <td></td>
              </tr>
              <tr>
                <td>msisdn</td>
                <td>业务号码</td>
              </tr>
              <tr>
                <td>order_no</td>
                <td>订单号</td>
              </tr>
              <tr>
                <td>price</td>
                <td>价格</td>
              </tr>
              <tr>
                <td>recharge_time</td>
                <td>充值时间</td>
              </tr>
              <tr>
                <td>active_time</td>
                <td>激活时间</td>
              </tr>
              <tr>
                <td>expired_time</td>
                <td>过期时间</td>
              </tr>
            </tbody>
          </table>
        </li>
      </ul>
    </div>
    <div class="saveBtn">
      <el-button size="small" type="primary" @click="submitBut">提交数据</el-button>
    </div>
  </div>
</template>
<script>
import { wechatCustom } from "@/api/api.js";
import { getWechatCustom } from "@/api/api.js";
export default {
  data() {
    return{
      userId:'',
      queryParams:{
        appId:"",
        secret:"",
        mchId:"",
        mckKey:"",
        callbackUrl:"",
      }
    }
  },
  methods: {
    // 获取列表的数据
    initData(){
      let params = {
        userId : this.userId
      };
      getWechatCustom(params).then(res=>{
        this.queryParams = res.data.data
      })
    },
    submitBut(){
      let params ={
        ...this.queryParams,
        userId : this.userId
      }
      wechatCustom(params).then(res =>{
        this.$notify({
            title: '成功',
            message: '信息提交成功',
            type: 'success'
          });
      })

    }
  },

  mounted() {

  },
  created() {
    this.userId = this.$route.params && this.$route.params.userId;
  }
};
</script>

<style scoped lang="less">
.parameter2{
  margin-top: 30px;
}
.lis{
  margin-top: 10px;
}
.span2{
  margin-left: 10px;
}
.config_form{
  width: 100%;
  color: #606266;
  p{
    font-weight: bold;
    font-size: 18px;
    color: #333333;
  }
  ul li{
    padding: 10px 0;
    font-size: 14px;
  }
  /deep/ .el-input{
    width: 280px;
    margin: 0 10px;
  }
}
.divImg{
  width: 354px;
  height: 766px;
  margin-top: 20px;
}
.li-can{
  p{
    color: #c7254e;
    font-size: 13px;
    margin: 10px 0;
  }
}
.paltformTable {
  border-collapse: collapse;
  width: 840px;
  background: #fff;
  font-size: 13px;
  margin-top: 5px;
  th{
    background: #eee;
    border: 1px solid #ddd;
    padding: 8px 10px;
  }
  td{
    border: 1px solid #ddd;
    padding: 8px 10px;
    font-size: 14px;
  }
}
.saveBtn{
  background: #F8F8F8;
  padding: 15px 0;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  margin-left: -50px;
  button{
    border-radius: 5px;
    font-size: 14px;
    width: 120px;
    height: 40px;
  }
}
</style>


